(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["PDP_Video_Popup"] && !Shopify.designMode) return;
  try {
    

 function pauseVideoOnClose(){
     
    document.querySelector('body').classList.remove('pdp-popup-active');

    document.querySelectorAll('iframe.video__player')?.forEach(function(iframe) {
      console.log(iframe);
      
      if ( iframe ) {
        var iframeSrc = iframe.src;
        iframe.src = iframeSrc;
      }
    });
   
    // Pause video
    var videoElm = document.querySelector('.pdp_video_popup video');
    videoElm?.pause();
 }

 // Click on play icon button
  document.querySelectorAll('.pdp-video__play__icon')?.forEach(function(playBtn){
    playBtn.addEventListener('click', function(){
      document.querySelector('body').classList.add('pdp-popup-active');
    })
  })

  // Click on close icon button
  document.querySelector('.pdp_video_popup .pdp-close').addEventListener('click', pauseVideoOnClose);

  // Click on overlay
  document.querySelector('.pdp_video_popup .pdp-popup-overlay').addEventListener('click', pauseVideoOnClose);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["animating-number-section"] && !Shopify.designMode) return;
  try {
    
  // Target element
      const counterElement = document.querySelector('.bm_number');

      // Counter variables
      const targetValue = 200;
      const animationDuration = 2000; // Animation duration

      let isAnimating = false;
      let isElementVisible = false;

      const startCounterAnimation = () => {
        if (isAnimating) return;

        isAnimating = true;
        let counter = 0;
        const increment = Math.ceil(targetValue / (animationDuration / 16)); // Update every 16ms 

        const animateCounter = () => {
          counter += increment;
          if (counter >= targetValue) {
            counter = targetValue;
            isAnimating = false;
          } else {
            requestAnimationFrame(animateCounter);
          }
          counterElement.textContent = counter;
        };

        animateCounter();
      };

      const resetCounter = () => {
        counterElement.textContent = 0;
      };

      const handleIntersection = (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (!isElementVisible) {
              resetCounter();
              isElementVisible = true;
              startCounterAnimation();
            }
          } else {
            if (isElementVisible) {
              resetCounter();
              isElementVisible = false;
            }
          }
        });
      };

      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5, 
      };

      const observer = new IntersectionObserver(handleIntersection, options);
      observer.observe(counterElement);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-video-section"] && !Shopify.designMode) return;
  try {
    
  
var videoElements = document.querySelectorAll('.bm-video-section');
videoElements.forEach(function(videoElement) {
  videoElement.addEventListener('click', function() {
    var parentElement = videoElement.parentElement;
    parentElement.classList.add('showcontrols');
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm_banner_quote"] && !Shopify.designMode) return;
  try {
    


    function waitForjQuery(trigger) {
      var interval = setInterval(function() {
        if (typeof window.jQuery != "undefined") {
        clearInterval(interval);
        trigger(window.jQuery);
        }
      }, 50);
      setTimeout(function() {
        clearInterval(interval);
      }, 15000);
      }



     function waitForSwiper(trigger) {
      var interval = setInterval(function() {
        if (typeof window.Swiper != 'undefined') {
        clearInterval(interval);
        trigger();
        }
      }, 50);
      setTimeout(function() {
        clearInterval(interval);
      }, 15000);
      }



   function waitForElement(selector, trigger) {
      var interval = setInterval(function() {
        if (document && document.querySelector(selector) && document.querySelectorAll(selector).length > 0) {
          clearInterval(interval);
          trigger();
        }
      }, 50);
      setTimeout(function() {
        clearInterval(interval);
      }, 15000);
    }


    function init() {
        waitForSwiper(function(){
          const swiper = new Swiper('.hero-swiper-mobile .swiper ', {
            pagination: false,
            // slidesPerView: 1,
              speed:850,
            loop: true,
            autoHeight: true,
              autoplay: {
                delay: 5000,
              },

            });
        })
      
    }
    

	  waitForjQuery(function(){
		$ = window.jQuery;	 
      waitForElement(".hero-swiper-mobile .swiper", init, 50, 5000);

      })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm_nira_percentage"] && !Shopify.designMode) return;
  try {
    




    function waitForjQuery(trigger) {
      var interval = setInterval(function() {
        if (typeof window.jQuery != "undefined") {
        clearInterval(interval);
        trigger(window.jQuery);
        }
      }, 50);
      setTimeout(function() {
        clearInterval(interval);
      }, 15000);
      }



     function waitForSwiper(trigger) {
      var interval = setInterval(function() {
        if (typeof window.Swiper != 'undefined') {
        clearInterval(interval);
        trigger();
        }
      }, 50);
      setTimeout(function() {
        clearInterval(interval);
      }, 15000);
      }



   function waitForElement(selector, trigger) {
      var interval = setInterval(function() {
        if (document && document.querySelector(selector) && document.querySelectorAll(selector).length > 0) {
          clearInterval(interval);
          trigger();
        }
      }, 50);
      setTimeout(function() {
        clearInterval(interval);
      }, 15000);
    }


    function init() {
        waitForSwiper(function(){
          const swiper = new Swiper('.hero-swiper-mobile .swiper ', {
            pagination: false,
            slidesPerView: 1,
              speed:850,
            loop: true,
            autoHeight: true,
              autoplay: {
                delay: 5000,
              },

            });
        })

    }
    
	  waitForjQuery(function(){
		$ = window.jQuery;	 
      waitForElement(".hero-swiper-mobile .swiper", init, 50, 5000);

      })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-instafeed"] && !Shopify.designMode) return;
  try {
    
  (function () {
  try {
    /* main variables */
    var debug = 0;
    var variation_name = "";

    /* helper library */
    var _$;
    !(function (factory) {
      _$ = factory();
    })(function () {
      var bm = function (s) {
        if (typeof s === "string") {
          this.value = Array.prototype.slice.call(document.querySelectorAll(s));
        }
        if (typeof s === "object") {
          this.value = [s];
        }
      };
      bm.prototype = {
        eq: function (n) {
          this.value = [this.value[n]];
          return this;
        },
        each: function (fn) {
          [].forEach.call(this.value, fn);
          return this;
        },
        log: function () {
          console && console.log(this);
        },
        addClass: function (v) {
          var a = v.split(" ");
          return this.each(function (i) {
            for (var x = 0; x < a.length; x++) {
              if (i.classList) {
                i.classList.add(a[x]);
              } else {
                i.className += " " + a[x];
              }
            }
          });
        },
        insertAfter: function (v) {
          return this.each(function (i) {
            i.insertAdjacentHTML('afterEnd', v);
          });
        },
        waitForElement: function (
          selector,
          trigger,
          delayInterval,
          delayTimeout
        ) {
          var interval = setInterval(function () {
            if (_$(selector).value.length) {
              clearInterval(interval);
              trigger();
            }
          }, delayInterval);
          setTimeout(function () {
            clearInterval(interval);
          }, delayTimeout);
        },
      };
      return function (selector) {
        return new bm(selector);
      };
    });

    function waitForSwiper(trigger) {
      var interval = setInterval(function () {
        if (typeof window.Swiper != "undefined") {
          clearInterval(interval);
          trigger();
        }
      }, 50);
      setTimeout(function () {
        clearInterval(interval);
      }, 15000);
    }
 function feedSlider() {
  waitForSwiper(function () {
    var swiper = new Swiper('.feed-slider', {
      slidesPerView: 6,
      loop:true,
      breakpoints: {
        0: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        767: {
          slidesPerView: 6,
          spaceBetween: 20,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },
      }
    });
  });
}


    
    

    function buildReviewSlides(resp) {
      var html = "";
      for (let i = 0; i < resp.length; i++) {
        html += `
      <div class="custome-instafeed swiper-slide">
      <div class="slide-container">
      <a href="${resp[i].link}" target="_blank">
        <div class="insta-img">
          <img src="${resp[i].images.thumbnail.url}">
          <div class="post-overlay">
            // <div class="icon">
            //   <img src="https://bm-test-dev.s3.us-east-2.amazonaws.com/growthHit/niraskin/01/instagram-icon-v2.svg">
            // </div>
          </div>
        </div>
      </a>
    </div>
    </div> `;
      }
      return html;
    }

    function feed_slider(resp) {
      var html = '' +
       
        '  <div class="insta-feed-slider">' +
        '<div class="username_container">' +
        ' <p class="nira_username">@nira_skin</p>' +
        '</div>' +
        '          <div class="swiper feed-slider">' +
        '              <div class="swiper-wrapper">' +
        '                  <!-- Slides -->' +

        buildReviewSlides(resp) +

        '              </div>' +
        ' <div class="swiper-button-prev"></div>' +
        ' <div class="swiper-button-next"></div>' +
        '              </div>' +

        '          </div>' +
        '  </div>';

      return html;

    }


    var helper = _$();
    /* Variation Init */
    function init() {
      _$('div .page-wrap').insertAfter('<div class="slider-bar"> </div>');


      var xhr = new XMLHttpRequest();
      xhr.addEventListener("readystatechange", function () {
        if (this.readyState === 4) {
          // console.log(this.responseText);
          var response = JSON.parse(this.responseText);

          var images = response.data;


          var html = feed_slider(images);
          document.querySelector('.slider-bar').innerHTML = html


          feedSlider();


        }
      });
      xhr.open("GET", "https://instafeed.nfcube.com/feed/v4?charge=0&fu=0&limit=36&account=nira-retail.myshopify.com&fid=0&hash=ef2bee448b7cf777e5de2bb7504b950a");
      xhr.send();
    }

    /* Initialise variation */
    helper.waitForElement("div .page-wrap", init, 50, 5000);
  } catch (e) {
    if (debug) console.log(e, "error in Test" + variation_name);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

  const faqItems = document.querySelectorAll("#footer .footer-menu");

              faqItems.forEach((item) => {
                  item.addEventListener("click", function () {
                      // Close all FAQ items
                      faqItems.forEach((item) => {
                          item.querySelector(".footer-block-content").parentElement.classList.remove("menu-m-active");
                      });

                      // Open the clicked FAQ item
                      this.querySelector(".footer-block-content").parentElement.classList.add("menu-m-active");
                  });
              });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-navigation"]) return;
  try {
    

  document.querySelector('li.c-accordion__header.Shop').addEventListener('click', function() {
  // this.classList.toggle("menu_color");
  document.querySelector('.real-result.shop').classList.add('shop_show');
  document.querySelector('.real-result.learn_more').classList.remove('learn_show');
});

document.querySelector('li.c-accordion__header.Learn').addEventListener('click', function() {
  // this.classList.toggle("menu_color");
  document.querySelector('.real-result.learn_more').classList.add('learn_show');
  document.querySelector('.real-result.shop').classList.remove('shop_show');
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nira-two-col-with-image-and-accordian"] && !Shopify.designMode) return;
  try {
    
    var seeMoreButton = document.querySelector('.see-more');
  seeMoreButton.addEventListener('click', function() {
    var productContainers = document.querySelectorAll('.mob-accordion');

    seeMoreButton.style.display = 'none';
    productContainers.forEach(function(accordion) {
      accordion.style.display = 'block';
    });
  });


     const accordionTitles = document.querySelectorAll(".accordionTitle");

          accordionTitles.forEach((accordionTitle) => {
              accordionTitle.addEventListener("click", () => {
                  if (accordionTitle.classList.contains("is-open")) {
                      accordionTitle.classList.remove("is-open");
                  } else {
                      const accordionTitlesWithIsOpen = document.querySelectorAll(".is-open");
                      accordionTitlesWithIsOpen.forEach((accordionTitleWithIsOpen) => {
                          accordionTitleWithIsOpen.classList.remove("is-open");
                      });
                      accordionTitle.classList.add("is-open");
                  }
              });
          });

var videoElement = document.querySelector('.Image_video_container');

  videoElement.addEventListener('click', function() {
    document.body.classList.add('showcontrols');
  });
if (window.screen.width<768){
  document.querySelector(".two-col-image-accordian .bm-mp4-video video source").src = "https://cdn.shopify.com/videos/c/o/v/9c87e259fe264acd8e76e8e0993276cf.mov";
  document.querySelector(".two-col-image-accordian .bm-mp4-video video").poster = "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Group_1.jpg?v=1692700011";
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-and-button-block"] && !Shopify.designMode) return;
  try {
    
  // Target element
      const counterElement = document.querySelector('.bm_number');

      // Counter variables
      const targetValue = 200;
      const animationDuration = 2000; // Animation duration

      let isAnimating = false;
      let isElementVisible = false;

      const startCounterAnimation = () => {
        if (isAnimating) return;

        isAnimating = true;
        let counter = 0;
        const increment = Math.ceil(targetValue / (animationDuration / 16)); // Update every 16ms 

        const animateCounter = () => {
          counter += increment;
          if (counter >= targetValue) {
            counter = targetValue;
            isAnimating = false;
          } else {
            requestAnimationFrame(animateCounter);
          }
          counterElement.textContent = counter;
        };

        animateCounter();
      };

      const resetCounter = () => {
        counterElement.textContent = 0;
      };

      const handleIntersection = (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (!isElementVisible) {
              resetCounter();
              isElementVisible = true;
              startCounterAnimation();
            }
          } else {
            if (isElementVisible) {
              resetCounter();
              isElementVisible = false;
            }
          }
        });
      };

      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5, 
      };

      const observer = new IntersectionObserver(handleIntersection, options);
      observer.observe(counterElement);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ticker-section"] && !Shopify.designMode) return;
  try {
    
  function live(selector, event, callback, context) {
			/****Helper Functions****/
			// helper for enabling IE 8 event bindings
			function addEvent(el, type, handler) {
				if (el.attachEvent) el.attachEvent("on" + type, handler);
				else el.addEventListener(type, handler);
			}
			// matches polyfill
			this &&
				this.Element &&
				(function (ElementPrototype) {
					ElementPrototype.matches =
						ElementPrototype.matches ||
						ElementPrototype.matchesSelector ||
						ElementPrototype.webkitMatchesSelector ||
						ElementPrototype.msMatchesSelector ||
						function (selector) {
							var node = this,
								nodes = (node.parentNode || node.document).querySelectorAll(selector),
								i = -1;
							while (nodes[++i] && nodes[i] != node);
							return !!nodes[i];
						};
				})(Element.prototype);
			// live binding helper using matchesSelector
			function live(selector, event, callback, context) {
				addEvent(context || document, event, function (e) {
					var found,
						el = e.target || e.srcElement;
					while (el && el.matches && el !== context && !(found = el.matches(selector))) el = el.parentElement;
					if (found) callback.call(el, e);
				});
			}
			live(selector, event, callback, context);
		}

		
var fnc_scrollto = function (to, id) {
			var smoothScrollFeature = "scrollBehavior" in document.documentElement.style;
			var articles = document.querySelectorAll("ul#content > li"),
				i;
			if (to == "elem") to = articles[id].offsetTop;
			var i = parseInt(window.pageYOffset);
			if (i != to) {
				if (!smoothScrollFeature) {
					to = parseInt(to);
					if (i < to) {
						var int = setInterval(function () {
							if (i > to - 30) i += 3;
							else if (i > to - 40) i += 3;
							else if (i > to - 80) i += 8;
							else if (i > to - 160) i += 18;
							else if (i > to - 200) i += 24;
							else if (i > to - 300) i += 40;
							else i += 60;
							window.scroll(0, i);
							if (i >= to) clearInterval(int);
						}, 10);
					} else {
						var int = setInterval(function () {
							if (i < to + 30) i -= 3;
							else if (i < to + 40) i -= 3;
							else if (i < to + 80) i -= 8;
							else if (i < to + 160) i -= 18;
							else if (i < to + 200) i -= 24;
							else if (i < to + 300) i -= 40;
							else i -= 60;
							window.scroll(0, i);
							if (i <= to) clearInterval(int);
						}, 10);
					}
				} else {
					window.scroll({
						top: to,
						left: 0,
						behavior: "smooth",
					});
				}
			}
		};

  } catch(e) { console.error(e); }
})();
})();
